const isHex = (hex: string) => !!hex.match(/^#?([a-f\d]{1,2}){3,4}$/i);

export default isHex;
